import { useCallback, useEffect } from 'react';

const KEY_NAME_ESC = 'Escape';
const KEY_EVENT_TYPE = 'keyup';

interface UseEscapeKeyProps {
    handleClose: () => void;
}

/**
 * Custom hook to handle the Escape key press event.
 * @param {UseEscapeKeyProps} props - The properties for the hook.
 */
function useEscapeKey(handleClose: () => void) {
    const handleEscKey = useCallback(
        (event: KeyboardEvent) => {
            if (event.key.toLowerCase() === KEY_NAME_ESC.toLowerCase() && typeof handleClose === 'function') {
                handleClose();
            }
        },
        [handleClose]
    );

    useEffect(() => {
        document.addEventListener(KEY_EVENT_TYPE, handleEscKey, false);

        return () => {
            document.removeEventListener(KEY_EVENT_TYPE, handleEscKey, false);
        };
    }, [handleEscKey]);
}

export default useEscapeKey;
